<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Yarı saydam siyah */
  z-index: 10;
  display: none;
}

</style>
<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
import HorizontalNav from "@/components/horizontal-nav";

import { layoutComputed } from "@/state/helpers";

/**
 * Horizontal-layout
 */
export default {
  props: {},
  components: {
    HorizontalNav,
      HorizontalTopbar,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");

  },
  mounted: ()=>{
      var dropdowns = document.querySelectorAll('.nav-item.dropdown');
      var overlay = document.querySelector('.overlay');

     
      dropdowns.forEach(function(dropdown) {
        dropdown.addEventListener('mouseenter', function() {
          overlay.style.display = 'block';
        });

        dropdown.addEventListener('mouseleave', function() {
          overlay.style.display = 'none';
        });
      });

      overlay.addEventListener('mouseenter', function() {
        overlay.style.display = 'none';
      });
 
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
};
</script>

<template>
  <div>
    <div id="background" ></div>
    <!-- Begin page -->
    <div id="layout-wrapper">
     <HorizontalTopbar type="light" :width="layoutWidth" />
      <HorizontalNav />
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content" >
          <div class="container-fluid">
            <slot />
          </div>
          <!-- container-fluid -->
        </div>
         <div class="overlay"></div>
        <!-- End Page-content -->
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
  </div>
</template>
